import { put, takeLatest, select } from 'redux-saga/effects';

import chatConsts from '../../chatConnection/constants';
import { subChannelsSelector } from '../selectors/channels';
import { activeChannelIdSelector } from '../../chatConnection/selectors';
import { actions as reqChannelParticipants } from '../reqChannelParticipants';

function* handleUserBlocked(action) {
  const { blockedIds, unblockedIds } = action.payload;
  const channelIds = blockedIds || unblockedIds;
  const blockedStatus = !!blockedIds;

  const params = {
    ids: channelIds,
    blocked: blockedStatus,
  };
  const activeChannelId = yield select(activeChannelIdSelector);
  if (activeChannelId) {
    yield put(reqChannelParticipants.send({ id: activeChannelId }));
  }
  yield put({
    type: chatConsts.UPDATE_BLOCKED_STATUS,
    payload: params,
  });

  const updatedChannels = yield select(subChannelsSelector);

  yield put({
    type: chatConsts.UPDATE_AVAILABLE_CHANNELS,
    payload: updatedChannels,
  });
}

export default function* handleUserBlockedSaga() {
  yield takeLatest([chatConsts.TOGGLE_BLOCKED_CHAT], handleUserBlocked);
}



// WEBPACK FOOTER //
// ./src/redux/board/sagas/handleBlockedUsers.js